import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";

function Home() {
  return <div className="hide-scrollbar">loading...</div>;
}

export default Home;
